import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {FieldService} from '../../services/FieldService';
import {InputText} from 'primeng/inputtext';
import {LayoutOptions} from '../../constants/layout-options';
import {Select} from 'primeng/select';
import {Button} from 'primeng/button';
import {Checkbox} from 'primeng/checkbox';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-radio',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    InputText,
    Select,
    Button,
    Checkbox
  ],
  template: `
    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox binary="true" [(ngModel)]="field.show_horizontally"/>
        <label>{{ Yii.t('app', 'Show Buttons Horizontally') }}</label>
      </div>
    </div>

    <div class="form-row flex-align-center">
      <label>
        {{ Yii.t('app', 'Layout') }}
      </label>
      <div>
        <p-select
          [(ngModel)]="field.layout"
          [options]="layouts"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        />
      </div>
    </div>
    @if (field.layout === 'horizontal') {
      <div class="form-row">
        <label></label>
        <div class="flex-row gap-8px flex-align-center">
          <input pInputText size="small" [(ngModel)]="field.labelWidth" type="number" min="10" max="90" step="1" style="width: 60px"/>
          <label>{{ Yii.t('app', 'Label width %') }}</label>
        </div>
      </div>
    }

    <div class="form-row">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox binary="true" [(ngModel)]="field.calculate_by_additional_val"/>
        <label>{{ Yii.t('app', 'Calculate By Additional Values') }}</label>
      </div>
    </div>

    @if (fieldsvc.ShowAddOptions(field)) {
      <div class="form-row">
        <label>{{ Yii.t('app', 'Field Options:') }}</label>
        <div>
          @for (option of field.field_options; track option.option_id) {
            <div class="flex-row gap-4px flex-align-center" style="margin-bottom: 4px">
              <span class="text-danger">*</span>
              <input
                type="text"
                pInputText
                size="small"
                [(ngModel)]="option.option_title"
                [placeholder]="(option.option_title) ? option.option_title : 'Option-' + (option.option_id + 1)"
                (change)="fieldsvc.OnFieldChanged.emit(field)"
                style="width: 70%;">
              @if (field.calculate_by_additional_val && (field.field_type === 'radio' || field.field_type === 'dropdown')) {
                <input
                  type="number"
                  pInputText
                  size="small"
                  [(ngModel)]="option.option_additional_value"
                  placeholder="Numeric Val"
                  (change)="fieldsvc.OnFieldChanged.emit(field)"
                  style="width: 10%;"/>
              }
              @if (!option.predefined) {
                <p-button
                  size="small"
                  icon="fa fa-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="fieldsvc.DeleteOption(field, option)"
                />
              }
              <span>{{ Yii.t('app', 'Value:') }}{{ option.option_value }}
                ;&nbsp; id= {{ option.option_id }}</span>
            </div>
          }
          <p-button
            (click)="fieldsvc.AddOption(field)"
            [label]="Yii.t('app', 'Add Option')"
            icon="fa fa-plus"
            size="small"
          />
        </div>
      </div>
    }
  `
})
export class FieldRadio {
  Yii = Yii;
  @Input() field: any;
  public layouts = LayoutOptions;

  constructor(public fieldsvc: FieldService) {
  }
}
